module.exports = __webpack_public_path__ + "img/bg-benefit.c919fa0b.webp";